import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tailwind.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Store } from './store';
import reducers from './reducers/reducers';

const root = createRoot(document.getElementById('root'));
root.render(
  <Store reducer={reducers} initialState={{}}>
    <App />
  </Store>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
